var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconShareUrl = function SvgIconShareUrl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_share_URL_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E7E8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.154 11v3.807c0 .799-.603 1.374-1.581 1.378-.983-.004-1.595-.579-1.59-1.378V11H6v3.88C5.996 16.12 7.014 17 8.573 17c1.545 0 2.568-.88 2.564-2.12V11h-.983ZM12.459 16.902h.983v-2.225H14.826l1.314 2.225h1.116l-1.43-2.384c.787-.273 1.18-.873 1.18-1.668 0-1.088-.737-1.85-2.242-1.85h-2.305v5.902Zm.983-3v-2.136h1.224c.951.004 1.349.42 1.349 1.085 0 .664-.398 1.047-1.35 1.051h-1.223ZM18.096 16.902H22v-.774h-2.921V11h-.983v5.902Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_share_URL_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgIconShareUrl;